import BaseComponent from '../base-component/base-component'
import { bodyElement } from '../../components/common/body-element'
import CartAPI from '../../api/cart-api'
import { fetchConfig } from '../../utils/fetch-config'
import { parseHTML } from '../../utils/dom'
import { debounce } from '../../utils/debounce'
import CartItem from './cart-item'

class Cart extends BaseComponent {
  cartAPI: CartAPI

  constructor() {
    super()

    this.cartAPI = new CartAPI()
  }

  connectedCallback(): void {
    this.addEventListener('change', this.handleCartChange)
    this.addEventListener('change', this.handleCartItemChange)
  }

  disconnectedCallback(): void {
    this.removeEventListener('change', this.handleCartChange)
    this.removeEventListener('change', this.handleCartItemChange)
  }

  handleCartItemChange = (event): void => {
    const itemIndex = +event.target.dataset.index
    const cartItem = this.querySelector<CartItem>(`#CartItem-${itemIndex}`)

    if (!cartItem) {
      return
    }

    cartItem.setLoading(true)
  }

  handleCartChange = debounce((event): void => {
    const itemIndex = +event.target.dataset.index
    const value = event.target.value

    this.updateItem(itemIndex, value)
  }, 500)

  createQueryConfig(itemIndex: number, quantity: number): any {
    const config = {
      ...fetchConfig(),
      body: JSON.stringify({
        line: itemIndex + 1,
        quantity,
        sections: this.dataset.sectionId,
        sections_url: window.location.pathname,
      }),
    }

    return config
  }

  updateItem(itemIndex: number, quantity: number): void {
    const cartItem = this.querySelector<CartItem>(`#CartItem-${itemIndex}`)

    if (!cartItem) {
      return
    }

    const config = this.createQueryConfig(itemIndex, quantity)

    const newQuantity = +quantity
    const currentQuantity = +(cartItem.dataset.quantity || 0)
    const hasDifferenceQuantity = currentQuantity === newQuantity
    const isZeroQuantity = newQuantity === 0

    if (hasDifferenceQuantity) {
      cartItem.setLoading(false)

      return
    }

    if (isZeroQuantity) {
      const cartItems = this.querySelectorAll('cart-item')
      const cartCount = cartItems.length

      this.updateEmptyStatus(cartCount === 1)

      cartItem.removeItem()
    }

    this.emit('start-update', {})

    cartItem.setDisabled(true)

    this.cartAPI
      .change(config)
      .then(state => {
        const parsedState = JSON.parse(state)

        cartItem.setDisabled(false)
        cartItem.setLoading(false)

        const node = parseHTML(parsedState.sections[this.dataset.sectionId])

        this.emit('update-nodes', { node })
      })
      .catch(() => {
        this.showError()
      })
  }

  purchaseHandler(parsedState): void {
    const node = parseHTML(parsedState.sections[this.dataset.sectionId])

    this.emit('update-nodes', { node })

    const cartItem = this.querySelector<CartItem>(
      `cart-item[data-variant-id="${parsedState.id}"]`,
    )

    if (!cartItem) {
      return
    }

    if (parsedState.quantity === 1) {
      cartItem
        .collapse()
        .then(() => cartItem.expand())
        .then(() => cartItem.showCheckmark())
    } else {
      cartItem.showCheckmark()
    }
  }

  showError(): void {
    if (!bodyElement.notification) {
      return
    }

    const { cartStrings }: any = window.auroraThemeLocales

    bodyElement.notification.show(cartStrings.error, 'warning')
  }

  updateEmptyStatus(isEmpty: boolean): void {
    this.toggleAttribute('is-empty', isEmpty)
  }
}

export default Cart
